import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';

import * as marked from 'marked';

import { OrganizationConfig } from '../../../../../../../../../models/organization-config';
import { OrganizationConfigService } from '../../../../../../../../../services/organization-config/organization-config.service';


@Component({
  selector: 'app-membership-cancellation-discount-offer-preview-modal',
  templateUrl: './membership-cancellation-discount-offer-preview-modal.component.html',
  styleUrls: ['./membership-cancellation-discount-offer-preview-modal.component.css']
})
export class MembershipCancellationDiscountOfferPreviewModalComponent implements OnInit {
  @Input() customerMessage: string;

  public orgConfig: OrganizationConfig = null;

  public isHoveringBackButton = false;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.orgConfig = this.orgConfigService.getOrganizationConfig();

    if (this.orgConfig === null) {
      this.orgConfigService
        .loadOrganizationConfig()
        .then(() => {
          this.orgConfig = this.orgConfigService.getOrganizationConfig();
        });
    }

    if (this.customerMessage.trim() === '') {
      this.customerMessage = '(your custom text here)';
    }
  }

  public getRenderedMarkdown(content: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(
      marked(
        content,
        {
          breaks: true
        }
      )
    );
  }
}
